export default __webpack_public_path__ + "static/media/coca_cola_logo_icon512.51282717.png";